import getMaintenanceWindowVariables from './maintenance';
import getTealiumVariables from './tealium';
import getAppDynamicsVariables from './appDynamics';

export default () => {
  if (!global.FORCE_LOCALE) {
    throw new Error('FORCE_LOCALE environment variable is not specified');
  } else if (!global.ENABLE_DESKTOP_JOURNEY) {
    throw new Error('ENABLE_DESKTOP_JOURNEY environment variable is not specified');
  } else if (!global.GSP_CONTACT_DETAILS_LOGIN_URL) {
    throw new Error('GSP_CONTACT_DETAILS_LOGIN_URL environment variable is not specified');
  }
  return {
    gspContactDetailsUrl: global.GSP_CONTACT_DETAILS_LOGIN_URL,
    forceLocale: global.FORCE_LOCALE === 'YES',
    desktopJourney: {
      isEnabled: global.ENABLE_DESKTOP_JOURNEY === 'YES',
    },
    maintenanceWindow: {
      ...getMaintenanceWindowVariables(),
    },
    tealium: {
      ...getTealiumVariables(),
    },
    appDynamics: {
      ...getAppDynamicsVariables(),
    },
  };
};
